<template>
    <div id="games-log-container" v-if="this.tab == 'history'">
        <div class="header-bg"></div>
        <div class="table-inner">
            <table class="games-log">
                <thead>
                <tr>
                    <th>
                        <div class=""><span>BUST</span></div>
                    </th>
                    <th>
                        <div class=""><span>@</span></div>
                    </th>
                    <th>
                        <div class=""><span>BET</span></div>
                    </th>
                    <th>
                        <div class=""><span>PROFIT</span></div>
                    </th>
                    <th>
                        <div class=""><span>HASH</span></div>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="game in this.game_history">
                    <td>
                        <a href="javascript:void(0)" :class="game.class_name" @click="doOpenGameInformation(game.game_id)">
                            <span>{{Clib.formatSatoshis(game.game_crash / 100, 2)}}</span><i>x</i>
                        </a>
                    </td>
                    <td><span>{{game.cashed_at}}</span></td>
                    <td><span>{{game.bet}}</span></td>
                    <td><span>{{game.profit}}</span></td>
                    <td class="td-hash">
                        <input readonly="" :value="game.hash"/>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "game-history",
        props: ['state', 'tab'],
        data: function()
        {
            return {
                utils: utils,
                Clib: Clib,
                MAX_GAMES_SHOWED: 50,
                game_history: [],
            };
        },
        created()
        {
            EventBus.$on('connected', this.updateGameHistories);
            EventBus.$on('game_crash', this.updateGameHistories);
        },
        beforeDestroy()
        {
            EventBus.$off('connected', this.updateGameHistories);
            EventBus.$off('game_crash', this.updateGameHistories);
        },
        mounted()
        {

        },
        beforeUpdate()
        {
            // console.log('game-history before update');
        },
        updated()
        {
            // console.log('game-history updated');
        },
        methods: {
            updateGameHistories()
            {
                // console.log('updateGameHistories');
                let self = this;

                self.game_history = [];

                for (let i = 0; i < this.state.game_history.length; i++) {
                    if (this.MAX_GAMES_SHOWED < i) {
                        return;
                    }
                    let game = this.state.game_history[i];
                    let cashed_at, bet, profit;
                    let player = game.player_info[self.state.user_id];

                    if (player) {
                        bet = parseFloat(player.bet);

                        if (player.stopped_at) {
                            profit = utils.toFixed(((player.stopped_at / 100) * player.bet) - player.bet);
                            cashed_at = Clib.formatSatoshis(player.stopped_at / 100) +'x';
                        } else {
                            profit = -bet;
                            cashed_at = '-';
                        }

                        profit = utils.comma(profit);
                        bet = utils.comma(bet);

                    } else {
                        cashed_at = '-';
                        bet = '-';
                        profit = '-';
                    }

                    let class_name;
                    if (game.game_crash >= 198) {
                        class_name = 'games-log-goodcrash';
                    } else if (game.game_crash <= 196) {
                        class_name = 'games-log-badcrash';
                    } else {
                        class_name = '';
                    }

                    self.game_history.push({
                        game_id: game.game_id,
                        game_crash: game.game_crash,
                        cashed_at: cashed_at,
                        bet: bet,
                        profit: profit,
                        class_name: class_name,
                        hash: game.hash,
                    });
                }
            },
            doOpenGameInformation(game_id)
            {
                // console.log(game_id)
                this.state.modals.game_information.display = true;
                this.state.modals.game_information.data.channel = this.state.channel;
                this.state.modals.game_information.data.game_id = game_id;
            }
        }
    }
</script>

<style scoped>

</style>
